//찾아 오시는 길
import { useState } from "react";
import NaverMap from "../../components/NaverMap";
import styles from "../../styles/profile/Map.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function Map() {
  const locations = [
    {
      name: "서울 본사",
      lat: 37.559453,
      lng: 126.833913,
      scale: 17,
      address: "서울시 강서구 공항대로 237 에이스타워마곡 1306호",
    },
    {
      name: "경기 지점",
      lat: 37.21077,
      lng: 127.100293,
      scale: 17,
      address: "경기도 화성시 동탄대로 636-3 메가비즈타워 C동 302호",
    },
  ];

  const [selected, setSelected] = useState(locations[0]);

  return (
    <div className={cx("mapPage")}>
      <div className={cx("title")}>
        <h4>찾아오시는 길</h4>
      </div>
      {/* 지역 선택 버튼 */}
      <div className={cx("locBtn")}>
        {locations.map((loc) => (
          <div
            key={loc.name}
            onClick={() => setSelected(loc)}
            className={cx({ active: selected.name === loc.name })}
          >
            {loc.name}
          </div>
        ))}
      </div>

      {/* 지도 */}
      <div className={cx("mapWrap", "reveal")}>
        <div className={cx("map")}>
          <NaverMap location={selected} />
        </div>
      </div>

      {/* 주소 */}
      <div className={cx("address", "reveal")}>
        <p>{selected.address}</p>
      </div>
    </div>
  );
}
